module.exports = __webpack_public_path__ + "static/media/Administrative Penalty Order - Roger Sherwood.8c8aa595.pdf";